module.exports = __webpack_public_path__ + "img/按钮4.dd65eba5.png";